// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  margin-top: 5em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-block {
  width: 440px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #F5F5F5;
  border-radius: 15px;
}

.login-form_title {
  margin: 40px 0;
  font-size: 24px;
  color: #434C63;
}

.login-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-input {
  margin-bottom: 20px;
  padding-left: 20px;
  width: 380px;
  height: 55px;
  font-size: 16px;
  border: 2px solid #EBEBEB;
  border-radius: 7px;
}

.login-btn {
  margin-bottom: 40px;
  width: 380px;
  height: 55px;
  font-size: 18px;
  color: #FFFFFF;
  background-color: #434C63;
  border: none;
  border-radius: 7px;
  box-shadow: 2px 3px 5px 1px rgba(67, 76, 99, .3);
  transition: background-color linear .3s, box-shadow linear 0.3s;
}

.login-btn:hover {
  cursor: pointer;
  background-color: #555c80;
  box-shadow: 2px 3px 5px 1px rgb(126, 126, 126);
}

@media screen  and (max-width: 520px) {
  .login-input {
    width: 320px;
    height: 50px;
  }

  .login-btn {
    width: 320px;
    height: 50px;
    font-size: 18px;
  }
}

@media screen  and (max-width: 480px) {
  .login-block {
    margin-top: 0;
    width: 350px;
  }

  .login-form_title {
    margin: 30px 0;
    font-size: 24px;
    color: #434C63;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".login-container {\n  margin-top: 5em;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-block {\n  width: 440px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #F5F5F5;\n  border-radius: 15px;\n}\n\n.login-form_title {\n  margin: 40px 0;\n  font-size: 24px;\n  color: #434C63;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-input {\n  margin-bottom: 20px;\n  padding-left: 20px;\n  width: 380px;\n  height: 55px;\n  font-size: 16px;\n  border: 2px solid #EBEBEB;\n  border-radius: 7px;\n}\n\n.login-btn {\n  margin-bottom: 40px;\n  width: 380px;\n  height: 55px;\n  font-size: 18px;\n  color: #FFFFFF;\n  background-color: #434C63;\n  border: none;\n  border-radius: 7px;\n  box-shadow: 2px 3px 5px 1px rgba(67, 76, 99, .3);\n  transition: background-color linear .3s, box-shadow linear 0.3s;\n}\n\n.login-btn:hover {\n  cursor: pointer;\n  background-color: #555c80;\n  box-shadow: 2px 3px 5px 1px rgb(126, 126, 126);\n}\n\n@media screen  and (max-width: 520px) {\n  .login-input {\n    width: 320px;\n    height: 50px;\n  }\n\n  .login-btn {\n    width: 320px;\n    height: 50px;\n    font-size: 18px;\n  }\n}\n\n@media screen  and (max-width: 480px) {\n  .login-block {\n    margin-top: 0;\n    width: 350px;\n  }\n\n  .login-form_title {\n    margin: 30px 0;\n    font-size: 24px;\n    color: #434C63;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
